import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Renders a module route only for users entitled to the matching all-in-one service.
 * Without the permission the user is sent back to the main map, so a direct URL or a
 * stale link cannot open a module that is hidden from the sidebar.
 */
function RequireService({ service, children }) {
  const { hasService } = useAuth();
  if (service && !hasService(service)) return <Navigate to="/" replace />;
  return children;
}

export default RequireService;
